<template>
  <div>
    <router-view />
    <!-- 定义全局弹层 -->
    <AbstractDialog v-model="dialogActiveName" :options="dialogParams" :sampleUnionId="sampleUnionId" />
    <NoticeDialog />
    <!-- 全局快捷搜索框 -->
    <global-search ref="globalSearchRef"></global-search>
    <!-- 小云实时来信侧边栏 -->
    <message-letters></message-letters>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NoticeDialog from '@/components/popover/noticeDialog';
import MessageNewCustome from './views/workspace/message/newCustomeTotalDialog'
import GlobalSearch from './views/workspace/globalSearch/search';
import MessageLetters from './views/workspace/message/messageLetter';
import {getToken} from '@/utils/auth';
export default {
  name: 'App',
  components: {
    NoticeDialog,
    GlobalSearch,
    MessageLetters
  },
  created () {
    // 判断当前是否有token
    if (getToken()) {
      this.$store.dispatch('user/initGlobalCompany');
      this.$store.dispatch('user/getUserInfoByToken');
      this.$store.dispatch('user/getCurrentWechatInfo');
      this.$store.dispatch('const/initNoticeList');
    }
    // 全局事件车
    this.$EventBus.$off('dialogChangeCall');
    this.$EventBus.$on('dialogChangeCall', this.dialogChangeCall);
    // 注册全局快捷搜索弹窗
    this.$EventBus.$off('quicklySearch');
    this.$EventBus.$on('quicklySearch', this.handleSearch);
  },
  data () {
    return {
      dialogActiveName: '',
      dialogParams: {},
      prevDialog: {},
      sampleUnionId: 0
    }
  },
  methods: {
    dialogChangeCall ({category, params = {}, isOnlyParams = false}) {
      this.dialogActiveName = category;
      this.dialogParams = {
        emitName: 'dialogChangeCall',
        ...params
      }
      if (!isOnlyParams) {
        // 两次名称一致
        if (category === this.prevDialog.categoryName) {
          this.sampleUnionId += 1;
        }
      }
      // 保存上次记录
      this.prevDialog = {
        categoryName: category,
        params: this.dialogParams,
      }
    },
    handleSearch (status) {
      if (this.$refs.globalSearchRef) {
        this.$refs.globalSearchRef.initial(status);
      }
    }
  }
}
</script>
